import * as React from "react";
// import { pure } from 'recompose';
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import Stream from "@tunnel-components/@sharded/widgets/stream/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    authorization,
    /*actionSeaPatterns,*/ acknowledged,
    item,
    actionLoader,
    isQualifyFunction,
  } = props;
  /**
   * @description : retourne un objet
   * @const
   * @name User
   * @type { any  }
   */
  /**
   * @description : le tableua relatif
   * à la position de l'incidents
   * @const
   * @name dataCar
   * @type { strin[]  }
   */
  const dataCar: string[] = [
    i18next.t("voie de gauche"),
    i18next.t("voie de droite"),
    i18next.t("parking"),
    i18next.t("bau"),
    i18next.t("trottoir"),
  ];
  // const User : any = Utils.createdUserRoles();
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <li className="vcartIncidents heightIncidents">
      <div className="cart-incident">
        <div className="cartIncidentHeader mixCartIncidentHeader">
          <div className="incidentHeaderTextleft">
            <span className="incidentLabel">{i18next.t("alerte tmd")} - </span>
            <span
              className="incidentLabel"
              style={{
                fontWeight: 500,
                color: "black",
                padding: "0 3px",
                borderRadius: "5px",
                marginLeft: "5px",
              }}
            >
              {item && item.cameraName}
            </span>
          </div>
        </div>
        <div className="cartIncidentContentInsider">
          <div className="cartIncidentContentIN">
            {actionLoader && (
              <div className="actionLoader">
                <div className="lds-spinner">
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </div>
            )}
            <div className="image-live  animated fadeIn">
              <div className="image-lapi">
                {item && (
                  <Stream
                    localUrl={item.contextImageUrl}
                    classnames="animated fadeIn"
                  />
                )}
              </div>
              <div className="image-lapi">
                {item && (
                  <Stream
                    localUrl={item.imageUrl}
                    classnames="animated fadeIn"
                  />
                )}
              </div>
            </div>
            <div className="incidentDateInfos">
              <div className="left part-left" style={{ lineHeight: "30px" }}>
                <span>{Utils.localDateFrFormat(item.insertedAt)}</span>
              </div>
              <div className="left part-right">
                <span
                  style={{
                    position: "absolute",
                    right: "2px",
                    top: "50%",
                    height: "25px",
                    lineHeight: "25px",
                    padding: "0 5px",
                    transform: "translateY(-50%)",
                    borderRadius: "3px",
                  }}
                  className="smallTubeColor"
                >
                  {dataCar[Number(item.laneId)]}
                </span>
              </div>
            </div>
          </div>
          {item && !acknowledged && (
            <div className="cart-incident-footer animated fadeInUp">
              <div className="footer-actions">
                <div className="left part-left">
                  <span>{i18next.t("acquitter")}</span>{" "}
                </div>
                <div className="left part-right">
                  {authorization && (
                    <span>
                      <div
                        onClick={isQualifyFunction}
                        title={i18next.t("acquitter")}
                        className="icon-check left"
                        style={{ marginRight: "0" }}
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          {item && acknowledged && (
            <div
              className="cart-incident-footer animated fadeInUp"
              style={{ backgroundColor: "white" }}
            >
              <div className="footer-actions">
                <div className="left part-left">
                  <span style={{ color: "#00E1B3" }}>
                    {i18next.t("acquitte")}
                  </span>{" "}
                </div>
                <div className="left part-right">
                  <span>
                    <div
                      className="icon-check-green left"
                      style={{ marginRight: "0" }}
                    />
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </li>
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  authorization: boolean;
  item: any;
  isQualifyFunction: any; // ok
  deleteFakeFunction: any; // ok
  impacts: boolean;
  actionLoader?: any[]; // ok
  actionFalseAlarmPatterns?: any;
  actionSeaPatterns?: any;
  index?: number; // ok
  onSubmitPatterns?: any;
  onSubmitSeaPatterns?: any;
  onCloseSeaPatterns?: any;
  onChangePatterns?: any;
  patternfalseAlarm?: any;
  itemslabelIncident?: any;
  actionFalseAlarmPatternsError?: any;
  identifiantActifSea?: any;
  onSearchValue?: any;
  selectedValue?: any;
  isQualifyFunctionFalse?: any; // ok
  onClosePattern?: any;
  rediRectToo?: any;
  acknowledged?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/incidents-tmd/component.tsx